import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';
import {IEditCountry} from '../../../../shared/services/configuration/countries/dtos/edit-country';
import { IEditRegion } from '../../../../shared/services/configuration/countries/dtos/edit-region';

export const useEditRegion = () => {
  return useMutation((payload: IEditRegion) => {
    return countriesService.editRegion(payload);
  });
};
